<!-- Zweck: Stellt die HTML-Struktur für shop dialogs tryadd art to wk confirm component im Frontend bereit. -->
<h1 mat-dialog-title>
  <table>
    <tr>
      <td style="padding-right: 20px">
        <svg-icon>info</svg-icon>
      </td>
      <td>
        {{title}}<br>
        <small>{{subtitle}}</small>
      </td>
    </tr>
  </table>
</h1>
<div mat-dialog-content style="min-height: 100px">
  <div style="font-size: 24px; padding: 20px; line-height: 28px;">
    <div style="margin-bottom: 5px" [innerHTML]="text|raw"></div>

    @if (currentAmount > 0) {
      <div style="font-size: 18px; margin-top: 18px; line-height: 24px;">
        @if (currentWkEntries.length > 0) {
          <div>Positionen im aktuellen Warenkorb:</div>
          <ul style="margin: 6px 0 12px 24px; padding: 0;">
            @for (position of currentWkEntries; track position.position) {
              <li>
                Position {{position.position}}: {{position.amount}} Stück
                @if (position.isTarget) {
                  <span> (gewählte Position)</span>
                }
              </li>
            }
          </ul>
        }

        <div><strong>Gesamtmenge derzeit: {{currentAmount}} Stück</strong></div>
        @if (targetPositionNumber !== null) {
          <div>Erhöht wird Position {{targetPositionNumber}} von {{targetPositionAmount}} auf {{targetPositionAmountAfterAdd}} Stück.</div>
        }
        <div><strong>Gesamtmenge danach: {{amountAfterAdd}} Stück</strong></div>
      </div>
    }
  </div>

  <div style="font-size: 18px; margin-top: 20px">
    Was wollen sie tun?
  </div>
</div>
<div mat-dialog-actions>
  <div style="text-align: center; width: 100%">
    @if (data.state.inCurrentWkAmount > 0) {
      <button style="margin: 5px" mat-flat-button (click)="setResponse('raiseAmount', data.amount)" matTooltip="Menge im Warenkorb erhöhen">
        Menge auf {{raiseAmount}} erhöhen
      </button>
    }

    @if (data.state.inCurrentWkAmount > 0) {
      <button style="margin: 5px" mat-stroked-button (click)="setResponse('setAmount', data.amount - data.state.inCurrentWkAmount)" matTooltip="Menge auf die gewünschte Menge ändern">
        Menge auf {{setAmount}} ändern
      </button>
    }

    @if (data.state.inCurrentWkAmount == 0) {
      <button style="margin: 5px" mat-flat-button (click)="setResponse('setAmount', data.amount)">
        Trotzdem in den Warenkorb legen
      </button>
    }

    <button style="margin: 5px" mat-raised-button (click)="setResponse('cancel', 0)">
      Abbrechen
    </button>
  </div>
</div>
